import styled from 'styled-components';
import { FootnoteMixin, Heading4Mixin } from '@qover/typography';

export const SummaryTermsCardContainer = styled.div`
  background-color: ${props => props.theme.colors.cardBackground()};
  color: ${props => props.theme.colors.textQuote()};
  padding: 20px;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    padding: 40px;
  }

  h4 {
    ${Heading4Mixin};
    margin: 0;
  }

  ul {
    margin-top: 20px;
    margin-left: calc(1em + 10px);

    li {
      ${FootnoteMixin};
    }

    li + li {
      margin-top: 12px;
    }
  }
`;
